import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'vue-multiselect/dist/vue-multiselect.css'
import { createApp } from 'vue'
import { createAuth } from './auth'
import App from './App.vue'
import router from './router'
import axiosInstance from './api/axios'
import i18n from './plugins/i18n'
import { defaultAuthProvider, getConfigByProvider } from './authConfig'
import { configureNavigationGuards } from './navigationGuards'
import { Buffer } from 'buffer'
import { savedAuthProvider } from './auth/providers/useProviderData'
import { useFavicon, useTitle } from '@vueuse/core'
import { APPLICATION_SUBPATH, AppMode } from './config'

const urlParams = new URLSearchParams(window.location.search)
const queryParamProvider = urlParams.get('provider')

const providerToUse =
  window.location.search.includes('provider=') && queryParamProvider
    ? getConfigByProvider(queryParamProvider)
    : savedAuthProvider.value
      ? getConfigByProvider(savedAuthProvider.value)
      : defaultAuthProvider

const auth = createAuth({
  router,
  autoConfigureNavigationGuards: true,
  provider: providerToUse,
  defaultPictureURL: '/img/user.svg',
  axios: {
    instance: axiosInstance,
    autoAddAuthorizationHeader: true,
  },
})
const BRAND_CONFIG: { [key: string]: { title: string; icon?: string } } = {
  saifty: {
    title: 'SAIFTY',
  },
  microbrains: {
    title: 'Microbrains',
    icon: '/microbrains/icon.png',
  },
  'industrial-identities': {
    title: 'Industrial Identities',
    icon: '/industrial-identities/icon.png',
  },
  'bayer-app': {
    title: 'SAIFTY',
    icon: `${APPLICATION_SUBPATH || '/'}favicon/favicon-32x32.png`,
  },
}
const THEMES: Record<AppMode, () => Promise<unknown>> = {
  saifty: () => import('@/assets/scss/themes/saifty.scss'),
  microbrains: () => import('@/assets/scss/themes/microbrains.scss'),
  'industrial-identities': () => import('@/assets/scss/themes/saifty.scss'),
  'bayer-app': () => import('@/assets/scss/themes/bayer-app.scss'),
}

const appMode = window.ENV.APP_MODE ?? 'saifty'
document.documentElement.classList.add(`mode-${appMode.toLowerCase()}`)
const THEME_TO_USE = THEMES[appMode as AppMode] ?? THEMES.saifty

const configFound = BRAND_CONFIG[appMode]
const configToUse = configFound ? configFound : BRAND_CONFIG['saifty']

useTitle(configToUse.title)
if (configToUse.icon) {
  useFavicon(configToUse.icon)
}

configureNavigationGuards(router)

window.Buffer = Buffer

const app = createApp(App)
app.use(router)
app.use(auth)
app.use(i18n)
app.provide('enable-route-transitions', true)
THEME_TO_USE().then(() => {
  app.mount('#app')
})
